import {Message} from 'element-ui';
import $http from './http.js'
import qs from 'qs';

const utils = {
    merge(target, source) {
        Object.keys(target).forEach(name => {
            target[name] = source[name];
        })
    },
    handleResult(result, done) {
        if (result['success']) {
            Message.success("操作成功！");
        } else {
            Message.success("操作失败！");
        }
        if (done) {
            done(result);
        }
    },
    getAuthToken() {
        return 'Bearer ' + sessionStorage.getItem("auth-token");
    },
    getApiPath(url) {
        return process.env.VUE_APP_HOST + url;
    },
    submit(formRef, url, data, done, error) {
        formRef.validate((valid) => {
            if (!valid) {
                return false;
            }

            $http.post(url, data).then(result => {
                if (result['success']) {
                    if (done) {
                        done(result.data);
                    }
                } else {
                    if (result['code'] === 901) {
                        if (error) {
                            error(result.data);
                        }
                    } else {
                        Message.error(result['message']);
                    }
                }
            });
        });
    },
    post(url, data, done, error) {
        $http.post(url, qs.stringify(data), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(result => {
            if (result['success'] === false) {
                if (error) {
                    error(result);
                }
            } else if (done) {
                done(result);
            }
        })
    },
    download(url) {
        let iframe = document.createElement('iframe');
        iframe.src = process.env.VUE_APP_HOST + url + (url.indexOf("?") > 0 ? "&" : "?") + "authorization=Bearer " + sessionStorage.getItem("auth-token");
        iframe.style.display = 'none';

        document.body.appendChild(iframe);
    }
};

export default utils;